import { useLocation, useRouter, useRouterState } from '@tanstack/react-router'
import { useLayoutEffect } from 'react'

/**
 * Troca o endereço por outro (sem criar entrada nova no histórico) e não
 * desenha nada. Usado para endereços antigos e páginas que mudaram de visão.
 *
 * Só age quando o roteador terminou de abrir o endereço atual: numa sequência
 * rápida de trocas (ex.: o link do comentário indo para o chamado), uma tela
 * que ainda está saindo não pode puxar a pessoa para outro lugar.
 */
export function Redirecionar({ para }: { para: string }) {
  const router = useRouter()
  const enderecoDaTela = useLocation({ select: (local) => local.href })
  const carregando = useRouterState({ select: (estado) => estado.status === 'pending' })
  useLayoutEffect(() => {
    if (carregando) return
    const atual = router.history.location
    if (atual.href !== enderecoDaTela) return
    if (`${atual.pathname}${atual.search}` !== para) router.history.replace(para)
  }, [para, router, enderecoDaTela, carregando])
  return null
}
